<template>
  <div class="container mt-0 mt-lg-4">
    <div class="row">
      <div class="col-lg-7 col-sm-12 text-left">
        <h5 class="font-weight-bolder mt-3 mb-0">
          Test your programming skills
        </h5>
        <h2 class="kova-text font-weight-bold mb-0 text-capitalize">{{ test.language }} Test</h2>
        <p>
          <font-awesome-icon icon="clock" class="mr-2" />
          {{ duration }} minutes
        </p>

        <div class="mt-4">
          <h4 class="font-weight-bolder text-left kova-text">
            Before you begin
          </h4>
          <p class="text-left">
            This exercise carries 50% of your vetting ﬁnal evaluation. Ensure
            you put in your best.
          </p>
          <h6 class="font-weight-bolder text-left">Instructions</h6>

          <div class="row">
            <div class="col-1 text-right">
              <font-awesome-icon
                class="kova-text"
                style="font-size:10px"
                icon="circle"
              ></font-awesome-icon>
            </div>
            <div class="col">
              <p class="text-left">
                There is no option to pause. Make sure you will not be
                interrupted for {{ duration }} minutes.
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-1 text-right">
              <font-awesome-icon
                class="kova-text"
                style="font-size:10px"
                icon="circle"
              ></font-awesome-icon>
            </div>
            <div class="col">
              <p class="text-left">
                If you accidentally close your browser, use the exam link to get
                back to your test
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-1 text-right">
              <font-awesome-icon
                class="kova-text"
                style="font-size:10px"
                icon="circle"
              ></font-awesome-icon>
            </div>
            <div class="col">
              <p class="text-left">
                Every part of this exercise requires only your presence and
                input. Avoid every form of distraction
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col"><p class="text-left">Good Luck!</p></div>
          </div>
        </div>
      </div>
      <div class="col-lg-5 col-sm-12 mt-lg-5">
        <div class="p-3">
          <button
            class="btn-kovatek px-5 py-2 text-size2"
            @click="$emit('update:show', true)"
          >
            Start The Test
          </button>
        </div>
      </div>
    </div>
    <hr />

    <div class="row">
      <div class="col-lg-4 col-sm-12">
        <h4 class="font-weight-bolder text-left kova-text">
          Do you need help?
        </h4>
        <p class="text-left">
          Do a sample test before indulging in the real test exercise
        </p>
      </div>

      <div class="col-lg-4 col-sm-12">
        <h4 class="font-weight-bolder text-left kova-text">
          FAQ
        </h4>
        <p class="text-left">
          Learn more about Codility
        </p>
      </div>

      <div class="col-lg-4 col-sm-12">
        <h4 class="font-weight-bolder text-left kova-text">
          Recruiter Report
        </h4>
        <p class="text-left">
          See how you will be graded and what information will be available to
          the recruiter
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    test: Object,
  },
  computed: {
    duration() {
      return this.test.duration || '30';
    }
  }
}
</script>

<style scoped>

.btn-kovatek {
  background-color: #20409a;
  font-weight: bold;
  outline: 0;
  border: 0;
  height: 45px;
  color: #fff;
  border-radius: 30px;
  transition: 0.25s;
  font-size: 18px;
}
.btn-kovatek:hover {
  background-color: #06216d;
  color: #fff;
}
</style>